module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Britannia-S1.059abe0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Britannia-S1.jpg
// module id = ZyVK
// module chunks = 0